import { React, useEffect, useState } from 'react';
import NavigationUser from '../../common/navigationUser/NavigationUser';
import { CustomButton, CustomSearch, message } from '../../utils/Utils';
import style from './combos.module.scss';
import {
  CheckOutlined,
  StarFilled,
  StarOutlined,
  PlusCircleOutlined,
  ShoppingOutlined,
  PlusOutlined,
  MinusOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import { OpenCombo } from './Modals/Modal';
import axios from '../../../config/apiConfig';
import { useParams } from 'react-router-dom';
import { Input, Radio, Spin } from 'antd';
import { LoadingOutlined, CheckCircleTwoTone } from '@ant-design/icons';
import { SmallModal } from '../../utils/Modals';
import apiConnect from '../../../config/apiConfig';
import { ProductsTable } from '../../products/ProductsTable';

const antIcon = <LoadingOutlined style={{ fontSize: '5rem' }} spin />;

const CombosTable = ({ comboTriggered }) => {
  const { container, combosItems } = style;
  const [supNav, setSupNav] = useState(false);
  const [openComboShow, setOpenComboShow] = useState(false);
  const [combos, setCombos] = useState([]);
  const [filteredCombos, setFilteredCombos] = useState([]);
  const [openCombo, setOpenCombo] = useState({});
  const [orders, setOrders] = useState([]);
  const [combosTotals, setCombosTotals] = useState({});
  const [subTotals, setSubTotals] = useState({});
  const [quantity, setQuantity] = useState({});
  const [orderTotal, setOrderTotal] = useState(0);
  const [filterText, setFilterText] = useState({});
  const [isView, setIsView] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [pharmacyAccount, setPharmacyAccount] = useState(null);
  const [role, setRole] = useState('pharmacy');
  const [productsList, setProductsList] = useState([]);
  const [filteredProductList, setFilteredProductList] = useState([]);
  const [selectedView, setSelectedView] = useState('combos');
  const { id } = useParams();

  const getCombos = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`/stands/${id}`);
      setCombos(response.data.data[0].combos);
      setFilteredCombos(response.data.data[0].combos);
    } catch (error) {
      message.error('Error al cargar los combos');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(async () => {
    const localRole = localStorage.getItem('role');
    if (localRole === 'supplier') {
      setRole(localRole);
      setSupNav(true);
      const { data } = await apiConnect.get(`/users/${id}/combos`);
      setCombos(data.data);
      setFilteredCombos(data.data);
    } else {
      getCombos();
    }
  }, []);

  const getProducts = async () => {
    try {
      setIsLoading(true);
      const response = await apiConnect.get(`/products/${id}`);
      setProductsList(response?.data?.data[0]?.products);
      setFilteredProductList(response?.data?.data[0]?.products);
    } catch (error) {
      message.error('Error al cargar los productos');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (role === 'supplier' && selectedView === 'products') {
      getProducts();
    }
  }, [selectedView]);

  useEffect(() => {
    if (comboTriggered?._id) {
      setOpenCombo(comboTriggered);
      setIsView(false);
      setOpenComboShow(true);
    }
  }, [comboTriggered]);

  const { loadingOverlay } = style;

  useEffect(() => {
    if (filterText !== '') {
      if (selectedView === 'combos') {
        setFilteredCombos(
          combos.filter((combo) =>
            combo.name
              .toLowerCase()
              .includes(filterText?.inputSearch?.toLowerCase()),
          ),
        );
      } else {
        setFilteredProductList(
          productsList.filter((product) =>
            product.description
              ?.toLowerCase()
              .includes(filterText?.inputSearch?.toLowerCase()),
          ),
        );
      }
    } else {
      setFilteredCombos(combos);
    }
  }, [filterText]);

  useEffect(() => {
    //calculate total
    const total =
      orders.reduce((acc, order) => {
        return acc + order.quantity * order.total;
      }, 0) || 0;
    setOrderTotal(total);
  }, [orders]);

  const handleOpenCombo = (combo, isView) => {
    setIsView(isView);
    setOpenCombo(combo);
    setOpenComboShow(!openComboShow);
  };

  const handleOrderQuantity = (order, action, e) => {
    const id = order.combo || order.product;
    let quantity = order.quantity;
    if (action === 'change') {
      const newValue = e.target.value;
      quantity = newValue;
      setOrders(
        orders.map((ord) => {
          if (ord.combo === id || ord.product === id) {
            const updatedOrder = { ...ord, quantity };
            if (
              order?.isSingleProduct &&
              updatedOrder.products &&
              updatedOrder.products.length > 0
            ) {
              updatedOrder.products[0] = {
                ...updatedOrder.products[0],
                quantity,
              };
            }
            return updatedOrder;
          }
          return ord;
        }),
      );
    }
    if (action === 'add') {
      quantity += 1;
      setOrders(
        orders.map((ord) => {
          if (ord.combo === id || ord.product === id) {
            const updatedOrder = { ...ord, quantity };
            if (
              order?.isSingleProduct &&
              updatedOrder.products &&
              updatedOrder.products.length > 0
            ) {
              updatedOrder.products[0] = {
                ...updatedOrder.products[0],
                quantity,
              };
            }
            return updatedOrder;
          }
          return ord;
        }),
      );
    } else if (action === 'subtract' && quantity > 1) {
      quantity -= 1;
      setOrders(
        orders.map((ord) => {
          if (ord.combo === id || ord.product === id) {
            const updatedOrder = { ...ord, quantity };
            if (
              order?.isSigleProduct &&
              updatedOrder.products &&
              updatedOrder.products.length > 0
            ) {
              updatedOrder.products[0] = {
                ...updatedOrder.products[0],
                quantity,
              };
            }
            return updatedOrder;
          }
          return ord;
        }),
      );
    }
  };

  const handleDeleteComboFromOrder = (combo) => {
    const id = combo._id;
    setOrders(orders.filter((order) => order.combo !== id));
  };

  const handleDeleteProductFromOrder = (product) => {
    const id = product.product;
    setOrders(orders.filter((order) => order.product !== id));
  };

  const handleSubmit = async () => {
    if (orders.length <= 0) {
      message.info('No hay combos en el pedido');
      return;
    }
    if (role === 'supplier' && !pharmacyAccount) {
      message.info('Ingrese el número de cuenta de la farmacia');
      return;
    }
    setIsLoading(true);
    const orderPromises = orders.map((order) => {
      return axios.post('/orders/', order, {
        params: {
          pharmacyAccount,
        },
      });
    });
    Promise.all(orderPromises)
      .then(() => {
        setIsLoading(false);
        setOrders([]);
        setOrderTotal(0);
        message.success('Pedido realizado con éxito');
        setShowConfirm(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
        message.error('Error al realizar el pedido');
        setShowConfirm(false);
      });
  };
  const toggleModal = (set, state) => {
    set(!state);
  };

  const handleChangePharmacyAccount = (e) => {
    e.preventDefault();
    if (e.target.value >= 0) {
      setPharmacyAccount(e.target.value);
    } else {
      setPharmacyAccount(0);
    }
  };

  return (
    <>
      {isLoading && (
        <div className={loadingOverlay}>
          <Spin size="large" indicator={antIcon} />
        </div>
      )}
      {!supNav && <NavigationUser brandSize="122px" shadow={true} />}
      {supNav && (
        <div className={style.selectView}>
          <p style={{ marginBottom: '0px' }}>Ver</p>
          <Radio.Group
            value={selectedView}
            onChange={(e) => setSelectedView(e.target.value)}
          >
            <Radio value="combos">Combos</Radio>
            <Radio value="products">Productos individuales</Radio>
          </Radio.Group>
          <span className={style.searchClient}>
            {supNav && (
              <span className={style.client}>
                <h2 style={{ margin: '0' }}>N° de cuenta:</h2>
                <Input
                  style={{ width: '90px' }}
                  type="number"
                  onChange={handleChangePharmacyAccount}
                  min={0}
                  value={pharmacyAccount}
                />
              </span>
            )}
          </span>
        </div>
      )}
      <div className={container}>
        <div>
          <div>
            <div>
              {supNav && selectedView === 'combos' ? (
                <h2>Listado de Combos</h2>
              ) : (
                <h2>Listado de Productos</h2>
              )}
            </div>
            <div>
              <div>
                <CustomSearch
                  placeholder="Buscar..."
                  setInput={setFilterText}
                />
              </div>
            </div>
          </div>
          <div>
            {selectedView === 'combos' &&
              filteredCombos.map((combo) => {
                const combosBoughtLoaded = localStorage.getItem('combosBought');
                const combosBought = JSON.parse(combosBoughtLoaded);
                const isComboBought = combosBought?.some(
                  (comboBought) => comboBought === combo._id,
                );
                const circleColor = isComboBought ? '#52c41a' : '#fff';
                return (
                  <div className={combosItems} key={combo._id}>
                    <div>
                      <div>
                        {combo?.starred ? <StarFilled /> : <StarOutlined />}
                      </div>
                      <div>
                        {<CheckCircleTwoTone twoToneColor={circleColor} />}
                      </div>
                      <div>
                        <h3>{combo?.name}</h3>
                      </div>
                    </div>
                    <div>
                      <CustomButton
                        content="Condiciones del Combo"
                        color="btnOutline"
                        onclick={() => handleOpenCombo(combo, true)}
                      />
                      {!orders.find((order) => order.combo === combo._id) ? (
                        <CustomButton
                          color="btnPrimary"
                          onclick={() => handleOpenCombo(combo, false)}
                          style={{ paddingRight: '1.8rem' }}
                        >
                          Agregar pedido
                          <PlusCircleOutlined
                            style={{ marginLeft: '.75rem', fontSize: '15px' }}
                          />
                        </CustomButton>
                      ) : (
                        <CustomButton style={{ paddingRight: '1.8rem' }}>
                          Agregado
                        </CustomButton>
                      )}
                    </div>
                  </div>
                );
              })}
            {selectedView === 'products' && (
              <ProductsTable
                productsList={filteredProductList}
                orders={orders}
                setOrders={setOrders}
                isLoading={isLoading}
              />
            )}
          </div>
        </div>
        <div>
          <div>
            <h2>Pedido</h2>
            <div>
              <ShoppingOutlined />
              <h2>${orderTotal?.toFixed(2)}</h2>
            </div>
          </div>
          <div>
            {orders.map((order) => (
              <div className={combosItems} key={order.combo}>
                {order.combo && (
                  <>
                    <div>
                      <h4>
                        {
                          combos.find((combo) => combo._id === order.combo)
                            ?.name
                        }
                      </h4>
                      <h4>{`(${
                        combos.find((combo) => combo._id === order.combo)
                          ?.products?.length
                      } artículos)`}</h4>
                    </div>
                    <div>
                      <div>
                        <MinusOutlined
                          onClick={() => handleOrderQuantity(order, 'subtract')}
                        />
                        {/* <div>{order.quantity}</div> */}
                        <Input
                          value={order.quantity}
                          style={{
                            width: '40px',
                            textAlign: 'center',
                            borderRadius: '5px',
                            margin: '0 5px',
                          }}
                          onChange={(e) =>
                            handleOrderQuantity(order, 'change', e)
                          }
                        />
                        <PlusOutlined
                          onClick={() => handleOrderQuantity(order, 'add')}
                        />
                      </div>
                      <div>
                        <h4>
                          $
                          {(
                            combosTotals[order.combo] * order.quantity
                          )?.toFixed(2)}
                        </h4>
                        <DeleteOutlined
                          onClick={() =>
                            handleDeleteComboFromOrder(
                              combos.find((combo) => combo._id === order.combo),
                            )
                          }
                        />
                      </div>
                    </div>
                  </>
                )}
                {order.product && (
                  <>
                    <span>
                      <h4 className={style.productName}>{order.name}</h4>
                    </span>
                    <div>
                      <div>
                        <MinusOutlined
                          onClick={() => handleOrderQuantity(order, 'subtract')}
                        />
                        <Input
                          value={order.quantity}
                          style={{
                            width: '40px',
                            textAlign: 'center',
                            borderRadius: '5px',
                            margin: '0 5px',
                          }}
                          onChange={(e) =>
                            handleOrderQuantity(order, 'change', e)
                          }
                        />
                        <PlusOutlined
                          onClick={() => handleOrderQuantity(order, 'add')}
                        />
                      </div>
                      <div>
                        <h4>${(order.total * order.quantity)?.toFixed(2)}</h4>
                        <DeleteOutlined
                          onClick={() => handleDeleteProductFromOrder(order)}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
          <div>
            <CustomButton
              onclick={() => setShowConfirm(true)}
              content="CONFIRMAR PEDIDO"
              color="btnPrimary"
              size="bg"
              style={{ width: '90%', padding: '.75rem 2.25rem' }}
            >
              <CheckOutlined style={{ marginRight: '1rem' }} />
            </CustomButton>
          </div>
        </div>
      </div>
      {openComboShow && (
        <OpenCombo
          combo={openCombo}
          set={setOpenComboShow}
          state={openComboShow}
          setOrders={setOrders}
          orders={orders}
          setTotal={setCombosTotals}
          total={combosTotals}
          orderTotal={orderTotal}
          setOrderTotal={setOrderTotal}
          setSubTotals={setSubTotals}
          subTotals={subTotals}
          setQuantity={setQuantity}
          quantity={quantity}
          isView={isView}
          supNav={supNav}
        />
      )}
      {
        <SmallModal
          title="¿Seguro que quiere realizar esta compra?"
          toggle={toggleModal}
          state={showConfirm}
          set={setShowConfirm}
          howManyBtn="2"
          firstBtn={{
            color: 'btnOutline',
            content: 'Cerrar',
            onclick: () => toggleModal(setShowConfirm, showConfirm),
          }}
          secondBtn={{
            color: 'btnPrimary',
            content: 'Confirmar compra',
            onclick: handleSubmit,
          }}
        />
      }
    </>
  );
};

export default CombosTable;
